// extracted by mini-css-extract-plugin
export default {"searchBox":"SearchBox_searchBox__Lmcbi","searchBoxText":"SearchBox_searchBoxText__27155","searchBoxInput":"SearchBox_searchBoxInput__AKITP"};